import type { Waypoint } from "@/components/application/map/route-map";
import { fetchSeaRoute } from "@/lib/sea-route-service";

/**
 * Database dei principali porti mondiali con coordinate precise
 */
export const MAJOR_PORTS: Record<string, { lat: number; lng: number; country: string; portName: string }> = {
    // Nord America
    "New York, USA": { lat: 40.684, lng: -74.041, country: "US", portName: "Port of New York" },
    "Los Angeles, USA": { lat: 33.7432, lng: -118.2648, country: "US", portName: "Port of Los Angeles" },
    "Panama, Panama": { lat: 9.3547, lng: -79.9014, country: "PA", portName: "Port of Balboa" },
    "Toronto, Canada": { lat: 43.6532, lng: -79.3832, country: "CA", portName: "Port of Toronto" },
    "Honolulu, USA": { lat: 21.3099, lng: -157.8581, country: "US", portName: "Port of Honolulu" },
    // Localized/extra
    "USA, Miami": { lat: 25.778, lng: -80.179, country: "US", portName: "Port of Miami" },
    "Miami, USA": { lat: 25.778, lng: -80.179, country: "US", portName: "Port of Miami" },

    // Europa
    "London, UK": { lat: 51.5074, lng: -0.1278, country: "GB", portName: "Port of London" },
    "Amsterdam, Netherlands": { lat: 52.3676, lng: 4.9041, country: "NL", portName: "Port of Amsterdam" },
    "Rotterdam, Netherlands": { lat: 51.9225, lng: 4.4781, country: "NL", portName: "Port of Rotterdam" },
    "Le Havre, France": { lat: 49.4944, lng: 0.1079, country: "FR", portName: "Port of Le Havre" },
    "Genoa, Italy": { lat: 44.4071, lng: 8.9339, country: "IT", portName: "Port of Genoa" },
    "Genova, Italy": { lat: 44.4071, lng: 8.9339, country: "IT", portName: "Port of Genoa" },
    "Genova": { lat: 44.4071, lng: 8.9339, country: "IT", portName: "Port of Genoa" },
    "Hamburg, Germany": { lat: 53.5511, lng: 9.9937, country: "DE", portName: "Port of Hamburg" },
    // Localized/extra (IT/ES/FR names used nei mock)
    "Porto di Genova, Italia": { lat: 44.4071, lng: 8.9339, country: "IT", portName: "Port of Genoa" },
    "Porto di Livorno, Italia": { lat: 43.551, lng: 10.303, country: "IT", portName: "Port of Livorno" },
    "Livorno, Italy": { lat: 43.551, lng: 10.303, country: "IT", portName: "Port of Livorno" },
    "Civitavecchia, Italia": { lat: 42.093, lng: 11.796, country: "IT", portName: "Port of Civitavecchia" },
    "Rotterdam, Paesi Bassi": { lat: 51.9225, lng: 4.4781, country: "NL", portName: "Port of Rotterdam" },
    "Barcellona, Spagna": { lat: 41.352, lng: 2.154, country: "ES", portName: "Port of Barcelona" },
    "Barcelona, Spain": { lat: 41.352, lng: 2.154, country: "ES", portName: "Port of Barcelona" },
    "FOS, Francia": { lat: 43.437, lng: 4.944, country: "FR", portName: "Port of Fos-sur-Mer" },
    "Fos-sur-Mer, France": { lat: 43.437, lng: 4.944, country: "FR", portName: "Port of Fos-sur-Mer" },
    "Marseille, France": { lat: 43.3549, lng: 5.3698, country: "FR", portName: "Port of Marseille" },
    "Marseille, Francia": { lat: 43.3549, lng: 5.3698, country: "FR", portName: "Port of Marseille" },
    "Marseille": { lat: 43.3549, lng: 5.3698, country: "FR", portName: "Port of Marseille" },

    // Asia
    "Shanghai, China": { lat: 31.2304, lng: 121.4737, country: "CN", portName: "Port of Shanghai" },
    "Shanghai": { lat: 31.2304, lng: 121.4737, country: "CN", portName: "Port of Shanghai" },
    "SHANGHAI": { lat: 31.2304, lng: 121.4737, country: "CN", portName: "Port of Shanghai" },
    "Hong Kong, China": { lat: 22.3193, lng: 114.1694, country: "CN", portName: "Port of Hong Kong" },
    "Hong Kong": { lat: 22.3193, lng: 114.1694, country: "CN", portName: "Port of Hong Kong" },
    "Singapore, Singapore": { lat: 1.2897, lng: 103.8501, country: "SG", portName: "Port of Singapore" },
    "Singapore": { lat: 1.2897, lng: 103.8501, country: "SG", portName: "Port of Singapore" },
    "Yokohama, Japan": { lat: 35.4437, lng: 139.638, country: "JP", portName: "Port of Yokohama" },
    "Yokohama": { lat: 35.4437, lng: 139.638, country: "JP", portName: "Port of Yokohama" },
    "Tokyo, Japan": { lat: 35.6762, lng: 139.6503, country: "JP", portName: "Port of Tokyo" },
    "Tokyo": { lat: 35.6762, lng: 139.6503, country: "JP", portName: "Port of Tokyo" },
    "Dubai, UAE": { lat: 25.2048, lng: 55.2708, country: "AE", portName: "Port of Jebel Ali" },
    "Dubai": { lat: 25.2048, lng: 55.2708, country: "AE", portName: "Port of Jebel Ali" },
    "India, Mumbai": { lat: 18.963, lng: 72.949, country: "IN", portName: "Port of Mumbai" },
    "Mumbai, India": { lat: 18.963, lng: 72.949, country: "IN", portName: "Port of Mumbai" },
    "India, Mundra": { lat: 22.839, lng: 69.721, country: "IN", portName: "Port of Mundra" },
    "Mundra, India": { lat: 22.839, lng: 69.721, country: "IN", portName: "Port of Mundra" },
    "Cina, Shanghai": { lat: 31.2304, lng: 121.4737, country: "CN", portName: "Port of Shanghai" },
    "Vietnam, Ho Chi Minh": { lat: 10.775, lng: 106.701, country: "VN", portName: "Ho Chi Minh City" },
    "Ho Chi Minh City, Vietnam": { lat: 10.775, lng: 106.701, country: "VN", portName: "Ho Chi Minh City" },
    "Thailandia, Bangkok": { lat: 13.736, lng: 100.523, country: "TH", portName: "Bangkok" },
    "Bangkok, Thailand": { lat: 13.736, lng: 100.523, country: "TH", portName: "Bangkok" },
    "Bangladesh, Chittagong": { lat: 22.335, lng: 91.832, country: "BD", portName: "Chittagong" },
    "Chittagong, Bangladesh": { lat: 22.335, lng: 91.832, country: "BD", portName: "Chittagong" },
    "Manila, Filippine": { lat: 14.582, lng: 120.979, country: "PH", portName: "Port of Manila" },
    "Manila, Philippines": { lat: 14.582, lng: 120.979, country: "PH", portName: "Port of Manila" },

    // Centro America
    "Costa Rica, San José": { lat: 9.935, lng: -84.087, country: "CR", portName: "Puerto Caldera" },
    "San José, Costa Rica": { lat: 9.935, lng: -84.087, country: "CR", portName: "Puerto Caldera" },
    "Guatemala City, Guatemala": { lat: 14.634, lng: -90.507, country: "GT", portName: "Puerto Quetzal" },

    // Sud America
    "Buenos Aires, Argentina": { lat: -34.6037, lng: -58.3816, country: "AR", portName: "Port of Buenos Aires" },
    "Santos, Brazil": { lat: -23.9608, lng: -46.3332, country: "BR", portName: "Port of Santos" },
    "Rio de Janeiro, Brazil": { lat: -22.9068, lng: -43.1729, country: "BR", portName: "Port of Rio de Janeiro" },
    "Brasile, Santos": { lat: -23.9608, lng: -46.3332, country: "BR", portName: "Port of Santos" },
    "Brasile, Rio de Janeiro": { lat: -22.9068, lng: -43.1729, country: "BR", portName: "Port of Rio de Janeiro" },
    "Perù, Callao": { lat: -12.061, lng: -77.118, country: "PE", portName: "Port of Callao" },
    "Lima, Peru": { lat: -12.061, lng: -77.118, country: "PE", portName: "Port of Callao" },
    "Guayaquil, Ecuador": { lat: -2.19, lng: -79.889, country: "EC", portName: "Port of Guayaquil" },
    "Colombia, Cartagena": { lat: 10.391, lng: -75.479, country: "CO", portName: "Port of Cartagena" },
    "Santiago, Chile": { lat: -33.45, lng: -70.666, country: "CL", portName: "Santiago (inland)" },

    // Africa
    "Cape Town, South Africa": { lat: -33.9249, lng: 18.4241, country: "ZA", portName: "Port of Cape Town" },
    "Cape Town": { lat: -33.9249, lng: 18.4241, country: "ZA", portName: "Port of Cape Town" },
    "Durban, South Africa": { lat: -29.8587, lng: 31.0218, country: "ZA", portName: "Port of Durban" },
    "Durban": { lat: -29.8587, lng: 31.0218, country: "ZA", portName: "Port of Durban" },
    "Kenya, Mombasa": { lat: -4.0435, lng: 39.6682, country: "KE", portName: "Port of Mombasa" },
    "Mombasa, Kenya": { lat: -4.0435, lng: 39.6682, country: "KE", portName: "Port of Mombasa" },
    "Mombasa": { lat: -4.0435, lng: 39.6682, country: "KE", portName: "Port of Mombasa" },
    "Ghana, Tema": { lat: 5.619, lng: -0.013, country: "GH", portName: "Port of Tema" },
    "Tema, Ghana": { lat: 5.619, lng: -0.013, country: "GH", portName: "Port of Tema" },
    "Tema": { lat: 5.619, lng: -0.013, country: "GH", portName: "Port of Tema" },
    "Ghana, Accra": { lat: 5.6037, lng: -0.187, country: "GH", portName: "Accra" },
    "Accra, Ghana": { lat: 5.6037, lng: -0.187, country: "GH", portName: "Accra" },
    "Accra": { lat: 5.6037, lng: -0.187, country: "GH", portName: "Accra" },
    "Somalia, Mogadishu": { lat: 2.0469, lng: 45.3182, country: "SO", portName: "Port of Mogadishu" },
    "Mogadishu, Somalia": { lat: 2.0469, lng: 45.3182, country: "SO", portName: "Port of Mogadishu" },
    "Mogadishu": { lat: 2.0469, lng: 45.3182, country: "SO", portName: "Port of Mogadishu" },
    "Mogadiscio": { lat: 2.0469, lng: 45.3182, country: "SO", portName: "Port of Mogadishu" },
    "Mogadiscio, Somalia": { lat: 2.0469, lng: 45.3182, country: "SO", portName: "Port of Mogadishu" },

    // Additional ports for mock data compatibility
    "Nairobi, Kenya": { lat: -1.286, lng: 36.817, country: "KE", portName: "Nairobi (inland)" },
    "Germania, Amburgo": { lat: 53.5511, lng: 9.9937, country: "DE", portName: "Port of Hamburg" },
    "Tailandia, Laem Chabang": { lat: 13.083, lng: 100.883, country: "TH", portName: "Port of Laem Chabang" },
    "Laem Chabang, Thailand": { lat: 13.083, lng: 100.883, country: "TH", portName: "Port of Laem Chabang" },
    "Messico, Veracruz": { lat: 19.173, lng: -96.133, country: "MX", portName: "Port of Veracruz" },
    "Veracruz, Mexico": { lat: 19.173, lng: -96.133, country: "MX", portName: "Port of Veracruz" },
};

/**
 * Trova un porto per nome (match esatto, case-insensitive o solo città)
 */
function findPort(name: string): { lat: number; lng: number; country: string; portName: string } | null {
    if (MAJOR_PORTS[name]) return MAJOR_PORTS[name];
    const lowerName = name.toLowerCase();
    for (const [key, value] of Object.entries(MAJOR_PORTS)) {
        if (key.toLowerCase() === lowerName) return value;
        const cityPart = key.split(",")[0].trim().toLowerCase();
        if (cityPart === lowerName) return value;
    }
    return null;
}

/**
 * Rotte predefinite per percorsi complessi
 */
const PREDEFINED_ROUTES: Record<string, string[]> = {
    // NY → Shanghai via Pacifico
    "New York, USA→Shanghai, China": ["New York, USA", "Panama, Panama", "Los Angeles, USA", "Honolulu, USA", "Yokohama, Japan", "Shanghai, China"],
    // Cape Town → Yokohama via Indiano
    "Cape Town, South Africa→Yokohama, Japan": [
        "Cape Town, South Africa",
        "Durban, South Africa",
        "Singapore, Singapore",
        "Hong Kong, China",
        "Yokohama, Japan",
    ],
    // Buenos Aires → NY via Atlantico
    "Buenos Aires, Argentina→New York, USA": ["Buenos Aires, Argentina", "Santos, Brazil", "Rio de Janeiro, Brazil", "Panama, Panama", "New York, USA"],
    // NY → London via Atlantico
    "New York, USA→London, UK": ["New York, USA", "London, UK"],
    // NY → Amsterdam via Rotterdam
    "New York, USA→Amsterdam, Netherlands": ["New York, USA", "Rotterdam, Netherlands", "Amsterdam, Netherlands"],
    // Berlin → Paris (sostituito con rotte marittime: Hamburg → Le Havre)
    "Berlin, Germany→Paris, France": ["Hamburg, Germany", "Le Havre, France"],
    // Toronto → Geneva (sostituito con rotte marittime: Toronto → NY → Rotterdam)
    "Toronto, Canada→Geneva, Switzerland": ["Toronto, Canada", "New York, USA", "Rotterdam, Netherlands"],
    // Berlin → Amsterdam (via Hamburg)
    "Berlin, Germany→Amsterdam, Netherlands": ["Hamburg, Germany", "Rotterdam, Netherlands", "Amsterdam, Netherlands"],
    // Toronto → Paris (via NY e Le Havre)
    "Toronto, Canada→Paris, France": ["Toronto, Canada", "New York, USA", "Le Havre, France"],
};

/**
 * Calcola uno o più punti intermedi lungo il great circle tra due coordinate (sfera).
 * Utile come fallback quando il plugin sea-routes non restituisce path (es. porto su terra).
 * @param lat1 lng1 punto iniziale (gradi)
 * @param lat2 lng2 punto finale (gradi)
 * @param count numero di punti intermedi (es. 2 → 3 segmenti)
 * @returns array di [lat, lng] (esclusi start/end)
 */
function greatCircleIntermediatePoints(
    lat1: number,
    lng1: number,
    lat2: number,
    lng2: number,
    count: number
): [number, number][] {
    if (count < 1) return [];
    const points: [number, number][] = [];
    const toRad = (d: number) => (d * Math.PI) / 180;
    const toDeg = (r: number) => (r * 180) / Math.PI;
    const φ1 = toRad(lat1);
    const λ1 = toRad(lng1);
    const φ2 = toRad(lat2);
    const λ2 = toRad(lng2);
    const d = 2 * Math.asin(Math.sqrt(
        Math.sin((φ2 - φ1) / 2) ** 2 +
        Math.cos(φ1) * Math.cos(φ2) * Math.sin((λ2 - λ1) / 2) ** 2
    ));
    if (d === 0) return [];

    for (let i = 1; i <= count; i++) {
        const f = i / (count + 1);
        const A = Math.sin((1 - f) * d) / Math.sin(d);
        const B = Math.sin(f * d) / Math.sin(d);
        const x = A * Math.cos(φ1) * Math.cos(λ1) + B * Math.cos(φ2) * Math.cos(λ2);
        const y = A * Math.cos(φ1) * Math.sin(λ1) + B * Math.cos(φ2) * Math.sin(λ2);
        const z = A * Math.sin(φ1) + B * Math.sin(φ2);
        const φi = Math.atan2(z, Math.sqrt(x * x + y * y));
        const λi = Math.atan2(y, x);
        points.push([toDeg(φi), toDeg(λi)]);
    }
    return points;
}

/**
 * Calcola la distanza tra due punti usando la formula di Haversine
 */
export function haversineDistanceKm(lat1: number, lng1: number, lat2: number, lng2: number): number {
    const R = 6371; // raggio terrestre in km
    const dLat = ((lat2 - lat1) * Math.PI) / 180;
    const dLon = ((lng2 - lng1) * Math.PI) / 180;
    const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos((lat1 * Math.PI) / 180) * Math.cos((lat2 * Math.PI) / 180) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
}

/**
 * Identifica segmenti marittimi tra waypoints
 * Tutti i segmenti tra waypoints sono considerati marittimi (sono tutti porti)
 */
export function identifySeaSegments(waypoints: Waypoint[]): Array<[number, number]> {
    const seaSegments: Array<[number, number]> = [];
    // Tutti i segmenti tra waypoints sono marittimi (tutti i waypoints sono porti)
    for (let i = 0; i < waypoints.length - 1; i++) {
        seaSegments.push([i, i + 1]);
    }
    return seaSegments;
}

/**
 * Genera waypoints realistici per una rotta marittima
 */
export function generateRealisticRoute(from: string, to: string, containerCreatedAt?: Date): Waypoint[] {
    const routeKey = `${from}→${to}`;

    // Verifica se esiste una rotta predefinita
    if (PREDEFINED_ROUTES[routeKey]) {
        const portNames = PREDEFINED_ROUTES[routeKey];
        const waypoints: Waypoint[] = [];

        portNames.forEach((portName, index) => {
            const port = MAJOR_PORTS[portName];
            if (!port) return;

            const isStart = index === 0;
            const isEnd = index === portNames.length - 1;
            const type = isStart ? "start" : isEnd ? "end" : "stop";

            // Calcola ETA/ATA basata sulla posizione nella rotta
            let eta: string | undefined;
            let ata: string | undefined;
            let status: "planned" | "in_transit" | "arrived" | "delayed" = "planned";

            if (containerCreatedAt) {
                // Tempo stimato: ~500km al giorno in mare, ~200km al giorno via terra
                const daysFromStart = index * 2; // Approssimazione
                const estimatedDate = new Date(containerCreatedAt.getTime() + daysFromStart * 24 * 60 * 60 * 1000);
                if (isEnd) {
                    ata = estimatedDate.toISOString();
                    status = "arrived";
                } else {
                    eta = estimatedDate.toISOString();
                    status = index === 0 ? "planned" : "in_transit";
                }
            }

            waypoints.push({
                id: `${portName}-${index}`,
                lat: port.lat,
                lng: port.lng,
                label: portName,
                type,
                info: {
                    portName: port.portName,
                    country: port.country,
                    eta,
                    ata,
                    status,
                    carrier: "MSC",
                    vessel: "MSC Seaview",
                    voyage: "MSC123",
                    notes: isStart ? "Merce caricata presso mittente" : isEnd ? "Container in consegna" : "Scalo intermedio",
                },
            });
        });

        return waypoints;
    }

    // Rotte non predefinite: usa solo porti di partenza e arrivo (rotta diretta via mare)
    const fromPort = findPort(from);
    const toPort = findPort(to);

    if (!fromPort || !toPort) {
        // Fallback: usa coordinate approssimative se i porti non sono nel database
        console.warn(`Porti non trovati nel database: ${from} → ${to}`);
        return [
            {
                id: "start",
                lat: 0,
                lng: 0,
                label: from,
                type: "start",
            },
            {
                id: "end",
                lat: 0,
                lng: 0,
                label: to,
                type: "end",
            },
        ];
    }

    // Rotta diretta con waypoints intermedi lungo il great circle (evita linea retta)
    const intermediates = greatCircleIntermediatePoints(
        fromPort.lat,
        fromPort.lng,
        toPort.lat,
        toPort.lng,
        2
    );
    const waypoints: Waypoint[] = [
        {
            id: "start",
            lat: fromPort.lat,
            lng: fromPort.lng,
            label: from,
            type: "start",
            info: {
                portName: fromPort.portName,
                country: fromPort.country,
                status: "planned",
                notes: "Partenza",
            },
        },
        ...intermediates.map(([lat, lng], i) => ({
            id: `gc-${i}`,
            lat,
            lng,
            type: "stop" as const,
        })),
        {
            id: "end",
            lat: toPort.lat,
            lng: toPort.lng,
            label: to,
            type: "end",
            info: {
                portName: toPort.portName,
                country: toPort.country,
                status: "arrived",
                notes: "Arrivo",
            },
        },
    ];

    return waypoints;
}

/**
 * Ottiene le coordinate di un porto dal database
 */
export function getPortCoordinates(cityName: string): { lat: number; lng: number } | null {
    const port = MAJOR_PORTS[cityName];
    if (!port) return null;
    return { lat: port.lat, lng: port.lng };
}

/**
 * Genera waypoints per una rotta marittima chiamando il backend (searoute).
 * Se l'API fallisce o i porti non sono trovati, fa fallback a generateRealisticRoute.
 */
export async function getSeaRouteWaypoints(
    from: string,
    to: string,
    containerCreatedAt?: Date
): Promise<Waypoint[]> {
    const routeKey = `${from}→${to}`;
    const portPairs: Array<{ from: { lat: number; lng: number }; to: { lat: number; lng: number } }> = [];

    if (PREDEFINED_ROUTES[routeKey]) {
        const portNames = PREDEFINED_ROUTES[routeKey];
        const ports = portNames.map((name) => findPort(name)).filter(Boolean) as Array<{
            lat: number;
            lng: number;
            country: string;
            portName: string;
        }>;
        if (ports.length < 2) return generateRealisticRoute(from, to, containerCreatedAt);
        for (let i = 0; i < ports.length - 1; i++) {
            portPairs.push({ from: ports[i], to: ports[i + 1] });
        }
    } else {
        const fromPort = findPort(from);
        const toPort = findPort(to);
        if (!fromPort || !toPort) return generateRealisticRoute(from, to, containerCreatedAt);
        portPairs.push({ from: fromPort, to: toPort });
    }

    const allCoords: [number, number][] = [];
    for (let i = 0; i < portPairs.length; i++) {
        const a = [portPairs[i].from.lat, portPairs[i].from.lng] as [number, number];
        const b = [portPairs[i].to.lat, portPairs[i].to.lng] as [number, number];
        let segment: [number, number][];
        try {
            const result = await fetchSeaRoute({
                originLat: a[0],
                originLng: a[1],
                destinationLat: b[0],
                destinationLng: b[1],
            });
            segment = result.coordinates?.length ? result.coordinates : [];
        } catch {
            segment = [];
        }
        if (segment.length === 0) {
            segment = [a, ...greatCircleIntermediatePoints(a[0], a[1], b[0], b[1], 3), b];
        }
        if (segment.length === 0) return generateRealisticRoute(from, to, containerCreatedAt);
        if (i === 0) {
            allCoords.push(...segment);
        } else {
            allCoords.push(...segment.slice(1));
        }
    }

    if (allCoords.length === 0) return generateRealisticRoute(from, to, containerCreatedAt);

    return allCoords.map(([lat, lng], i) => ({
        id: `sea-${i}`,
        lat,
        lng,
        type: i === 0 ? "start" : i === allCoords.length - 1 ? "end" : "stop",
    }));
}
